import { FC, ReactElement, ReactNode } from 'react';

import { Box, Card, Divider, Heading, HStack, Text, VStack } from '@bonusly/design-system';

export type ExperimentCardProps = {
	icon: ReactElement;
	iconBg?: string;
	iconFg?: string;
	title: string;
	description: string;
	footer: ReactNode;
	// feedbackUrl?: string; // TODO(labs): uncomment when a feedback destination is chosen
};

export const ExperimentCard: FC<ExperimentCardProps> = ({ icon, iconBg = 'primary.bgAlpha', iconFg = 'primary.fg', title, description, footer }) => {
	return (
		<Card p={5} gap={4} shadow="none" borderWidth="1px" borderColor="border.default" data-testid="experiment-card">
			<VStack align="stretch" spacing={4}>
				<HStack spacing={3} align="center">
					<Box bg={iconBg} color={iconFg} borderRadius="md" p={2} display="flex" alignItems="center" justifyContent="center">
						{icon}
					</Box>
					<Heading size="md">{title}</Heading>
				</HStack>
				<Text color="text.softer">{description}</Text>
				<Divider />
				<HStack justify="space-between" align="center" minH={6}>
					<Box>{footer}</Box>
					{/* TODO(labs): feedback link goes here once the destination is picked */}
				</HStack>
			</VStack>
		</Card>
	);
};
